import PropTypes from 'prop-types';
import Breadcrumbs from '../../../components/Breadcrumbs';
import Components from './Components';
import Hero from './Hero';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PageHomepage = function PageHomepage(_ref) {
  var id = _ref.id,
      pageTitle = _ref.pageTitle,
      title = _ref.title,
      subtitle = _ref.subtitle;
  return /*#__PURE__*/_jsxs("section", {
    children: [pageTitle && /*#__PURE__*/_jsx(Breadcrumbs, {
      pageTitle: pageTitle
    }), title && subtitle && /*#__PURE__*/_jsx(Hero, {
      title: title,
      subtitle: subtitle
    }), /*#__PURE__*/_jsx(Components, {
      id: id
    })]
  });
};

PageHomepage.defaultProps = {
  pageTitle: '',
  subtitle: '',
  title: ''
};
PageHomepage.propTypes = {
  id: PropTypes.string.isRequired,
  pageTitle: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string
};
export default PageHomepage;